import React, { Component } from "react";
import NavBar from "../../Components/NavBar/NavBar";
import AuthCheck from "../../Components/Utils/AuthCheck";

export class Applicant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    AuthCheck(this.props);
  }

  render() {
    document.title = "Applicant | Admin | User Information";
    var liscenceurl = "";
    var firstname = "";
    if (this.props.location.state) {
      const { doctor } = this.props.location.state;
      liscenceurl = doctor.liscenceurl;
      firstname = doctor.firstname;
      console.log(liscenceurl);
    }
    return (
      <div style={{ marginBottom: 50 }}>
        <NavBar loggedIn={true} />
        <div className="container center">
          <h4>{firstname}'s Liscence</h4>
          <img alt={firstname} src={liscenceurl} width="500" />
        </div>
        <div className="container center">
          <h4>Attach accept/decline button here</h4>
        </div>
      </div>
    );
  }
}

export default Applicant;
